<div class="header-wrapper gl-min-width" style="background: #fff">
  <div class="header-content gl-container-width">
    <div class="logo-group">
      <a href="/2022">
        <img class="logo1" src="assets/2022/imgs/logo1@2x.png" width="194px" height="60px"/>
        <img class="logo2" src="assets/2022/imgs/logo2@2x.png" width="110px" height="54px" style="margin-left: 20px"/>
      </a>
    </div>
    <div class="navs-group">
      <div class="nav-item" *ngFor="let item of navs;let i=index;let is_last = last;">
        <div class="nav-t" [ngClass]="{'active':i===navi}">
          <a [href]="item.url" [target]="item.blank ? '_blank' : ''">
            {{item.title}}
          </a>
        </div>
        <div class="nav-line" *ngIf="!is_last"></div>
      </div>
    </div>
  </div>
</div>
<div class="body-wrapper">
  <ng-content></ng-content>
</div>
<div class="footer-wrapper gl-min-width">
  <div class="footer-container">
    <div class="footer-main">
      <div class="footer-logo">
        <a href="/2022">
          <img src="/assets/2022/imgs/logo1_footer@2x.png" alt="" width="182px" height="58px">
          <img src="/assets/2022/imgs/logo2_footer@2x.png" alt="" style="margin-left: 40px" width="276px" height="40px">
        </a>
      </div>
      <div class="footer-content">
          <div class="content">
            <div class="title">
              <div class="title-point"></div>网站导航
            </div>
            <div class="footer-nav" *ngFor="let navs of footernavs;">
              <div *ngFor="let item of navs;let last = last" [style]="!last ? 'width:215px' : ''">
                <a [href]="item.url" class="footer-a">{{item.title}}</a>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="title">
              <div class="title-point"></div>联系我们
            </div>
            <div class="footer-nav" style="justify-content: space-between;">
              <div>邮箱：{{email}}</div>
              <div style="text-align:center">
                <img src="/assets/2022/imgs/code1@2x.jpg" alt="" width="136px" height="136px">
                <p style="margin: 0;">微信公众号</p>
              </div>
              <div style="text-align:center">
                <img src="/assets/2022/imgs/code2@2x.jpg" alt="" width="136px" height="136px">
                <p style="margin: 0;">扫码小程序观看教博会</p>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="footer-bg">
    <img [src]="S_ROOT_URL + '/app/edu-expo/2022/pc/footer_bg.jpg?x-oss-process=image/resize,w_1920'" height="416px" width="100%"/>
  </div>
  <div class="footer-beian">
    ©上海教育博览会 &nbsp;&nbsp; <a href=" https://beian.miit.gov.cn/" target="_blank">沪ICP备05052062号-1</a> &nbsp;&nbsp; <img src="/assets/2022/imgs/footer-icon2@2x.png"/> 沪公网安备：31009102000050号
  </div>
</div>

